module.exports = __webpack_public_path__ + "pk.79e8d1d7f368f70bd0d8.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/pk.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/pk.svg
// module chunks = styles